"use client";

import ErrorBoundry from "@/components/ErrorBoundary";

export default function GlobalError({ error }: { error: Error }) {
  return (
    <html>
      <body>
        <ErrorBoundry error={error} />
      </body>
    </html>
  );
}
